import { useState } from 'react';
import TermsModal from './TermsModal';

const Footer = () => {
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <>
      <footer className="w-full bg-[#2e032e] text-white py-12 px-6 border-t border-white/10">
        {/* Top: Navigation Links */}
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-base font-medium mb-6 text-white/90">
          <a href="/buy" className="hover:text-white transition">Buy $STBOX</a>
          <a href="https://shutthebox.io/alpha_a/index.html" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Play</a>
          <a
            href="https://dexscreener.com/bsc/0xb692e9099a6b275cfc990c994f0d62cca2284444:4meme"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition"
          >
            Dexscreener
          </a>

          <a
            href="https://x.com/ShutTheBox_io"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition"
          >
            X.com
          </a>
          <a
            href="https://discord.com/channels/1401609743650521239/1401611402715861123"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition"
          >
            Discord
          </a>
        </div>

        {/* Bottom: Legal */}
        <div className="text-center text-sm text-white/60">
          <button
            onClick={() => setTermsOpen(true)}
            className="underline hover:text-white mr-2 transition"
          >
            Terms & Conditions
          </button>
          <span className="mx-1">•</span>
          <span>© {new Date().getFullYear()} Shut The Box. All rights reserved.</span>
        </div>
      </footer>

      <TermsModal open={termsOpen} onClose={() => setTermsOpen(false)} />
    </>
  );
};

export default Footer;
